import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

interface CategoryNavProps {
  activeSlug?: string;
}

export default function CategoryNav({ activeSlug }: CategoryNavProps) {
  return (
    <div className="w-full px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeSlug === cat.slug
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200/70"
              }`}
            >
              <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}